export { default } from './CancelHoldButton';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/CancelHoldButton/index.js